<template>
<div>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline">Auditoría de Poderes</h3>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assemblies"
      :search="search"
      :loading="loadingTable"
      :rows-per-page-text="$t('datatable.rowsPerPageText')"
      :no-results-text="$t('datatable.noResultsText')"
      :no-data-text="$t('datatable.noDataText')"
      :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.assembly_date }} {{ props.item.assembly_time }}</td>
        <td class="text-xs-center" >
          <v-tooltip right>
                <template v-slot:activator="{ on }">
                <v-icon v-on="on" :class="props.item.assembly_type == 'virtual' ? 'blue--text' : 'purple--text'">{{ $t(`assembly.assembly_types.icons.${props.item.assembly_type}`) }}</v-icon>
                </template>
                <span >{{ $t(`assembly.assembly_types.${props.item.assembly_type}`) }}</span>
            </v-tooltip>
            </td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-left">{{ props.item.responsible_name }}</td>
            <td class="text-xs-center">{{ props.item.delegated_powers_limit }}</td>
            <td class="text-xs-center">{{ props.item.min_attendance_percentage }}</td>
            <td class="text-xs-center" :class="props.item.status == 1 || props.item.status == 2 ? 'red--text' : ''">{{ props.item.status == 0 ? 'Abierta' : props.item.status == 1 ? 'Cerrada' : 'Eliminada' }}</td>
            <td class="text-xs-center" v-if="props.item.status !== 2">
              <!-- v-if="props.item.assembly_type == 'virtual'" -->
            <v-tooltip  top>
                <v-icon
                medium
                class="mr-2"
                @click="auditPowers(props.item)"
                slot="activator"
            >
                find_in_page
            </v-icon>
            <span>Auditoría de poderes</span>
            </v-tooltip>
        </td>
        <td v-else></td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-card>
  <v-layout row justify-center>
    <v-dialog v-model="dialogAudit" max-width="980px">
      <v-card>
        <v-card-title>
          <span class="headline">Auditoría de poderes - {{ selectedAssembly.description }}</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="auditPowerSearch"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row class="ma-0 pa-0">
            <v-data-table
              :headers="auditPowerHeaders"
              :items="auditPowerItems"
              :search="auditPowerSearch"
              :items-per-page="10"
              :rows-per-page-text="$t('datatable.rowsPerPageText')"
              :no-results-text="$t('datatable.noResultsText')"
              :no-data-text="$t('datatable.noDataText')"
              :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
              :loading="isLoading"
              class="mt-2 table-striped"
              style="width: 100%"
            >
              <template slot="items" slot-scope="props">
                <td class="no-wrap" :style="!!props.item.reviewed ? 'background-color: #Ebffeb' : ''">
                  <v-hover>
                    <v-btn 
                      v-if="props.item.document_signed" 
                      @click="selectedAssembly.status != 1 ? checkPower(props.item.id, !!props.item.reviewed) : myAlert('Asamblea cerrada, no es posible cambiar estado')"
                      :title="!!props.item.reviewed ? 'Revisado: '+props.item.reviewed : 'Marcar como revisado'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${!!props.item.reviewed ? hover ? 'green lighten-2' : 'green lighten-2' : 'grey'}`"
                      flat icon small >
                      <v-icon>check_circle_outline</v-icon>
                    </v-btn>
                  </v-hover> 
                  {{ props.item.family_name }}
                  <v-tooltip top color="info">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" flat icon small color="blue lighten-2" 
                        @click="showPowersHistory(props.item.family_id, props.item.family_name)">
                        <v-icon>info</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver detalle</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-center">
                    <span v-show="props.item.asopaf === 1" class="mx-1 green--text text--lighten-2">
                      Asopaf
                    </span>
                    <span v-show="props.item.employee === 1" small class="mx-1 green--text text--lighten-2">
                      Empleado
                    </span>
                </td>
                <td class="text-xs-center" :class="props.item.document_status == 'R' ? 'red--text text--darken-2' : ''">
                    <v-hover>
                      <v-btn 
                        v-if="['F','R'].includes(props.item.document_status)" 
                        @click="viewPower(props.item.document_signed)"
                        :title="props.item.document_status == 'R' ? 'Rechazado por administrador' : 'Ver poder'"
                        slot-scope="{ hover }"
                        class="mx-0"
                        :color="`${props.item.document_status == 'F' ? hover ? 'blue lighten-2' : 'grey' : 'red'}`"
                        flat icon small >
                        <v-icon>launch</v-icon>
                      </v-btn>
                    </v-hover>
                    <v-hover>
                      <v-btn
                        v-if="['F'].includes(props.item.document_status) &&  selectedAssembly.status != 1"
                        @click="rejectPowerPrompt(props.item.document_signed, props.item.family_id, props.item.family_name)"
                        title="Rechazar poder"
                        :color="`${hover ? 'red darken-2' : 'grey'}`"
                        class="mx-0"
                        slot-scope="{ hover }"
                        flat icon small  >
                        <v-icon>highlight_off</v-icon>
                      </v-btn>
                    </v-hover>
                    <span>{{ !['F','R'].includes(props.item.document_status) ? 'Sin firmar' : '' }}</span>
                </td>
                <td class="no-wrap" :style="!!props.item.receives_reviewed ? 'background-color: #Ebffeb' : ''">
                  <v-hover>
                    <v-btn 
                      v-if="props.item.family_receives_vista_id" 
                      @click="selectedAssembly.status != 1 ? checkPower(props.item.id_receives, !!props.item.receives_reviewed) : myAlert('Asamblea cerrada, no es posible cambiar estado')"
                      :title="!!props.item.receives_reviewed ? 'Revisado: '+props.item.receives_reviewed : 'Marcar como revisado'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${!!props.item.receives_reviewed ? hover ? 'green lighten-2' : 'green lighten-2' : 'grey'}`"
                      flat icon small >
                      <v-icon>check_circle_outline</v-icon>
                    </v-btn>    
                  </v-hover> 
                  {{ props.item.family_receives_name }}
                </td>
                <td class="text-xs-center" :title="props.item.family_receives_power_updated_at ? props.item.family_receives_power_updated_at.substring(0,16) : ''" v-html="props.item.family_receives_power_status == 'A' ? 'Aceptado' : props.item.family_receives_power_status == 'R' ? 'Rechazado<br>apoderado' : 'Pendiente'"></td>
                <td class="text-xs-center"  :class="props.item.family_receives_vista_status == 'P' ? 'red--text text--darken-2' : ''">
                  <v-hover>
                    <v-btn 
                      v-if="props.item.family_receives_vista_id && props.item.family_receives_power_status == 'A'" 
                      @click="viewPower(props.item.family_receives_vista_id)"
                      :title="props.item.family_receives_vista_status == 'R' ? 'Rechazado por administrador' : 'Ver poder'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${props.item.family_receives_vista_status == 'F' ? hover ? 'blue lighten-2' : 'grey' : 'red'}`"
                      flat icon small >
                      <v-icon>launch</v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover>
                    <v-btn
                      v-if="props.item.family_receives_vista_id && props.item.family_receives_power_status == 'A' && selectedAssembly.status != 1"
                      @click="rejectPowerPrompt(props.item.family_receives_vista_id, props.item.family_receives_power_id, props.item.family_receives_name)"
                      title="Rechazar poder"
                      :color="`${hover ? 'red darken-2' : 'grey'}`"
                      class="mx-0"
                      slot-scope="{ hover }"
                      flat icon small  >
                      <v-icon>highlight_off</v-icon>
                    </v-btn>
                  </v-hover>              
                  <span v-html="props.item.family_receives_vista_status == 'R' ? 'Rechazado<br>administrador' : props.item.family_receives_vista_status != 'F' && props.item.family_receives_power_status != 'R' ? 'Sin firmar' : ''"></span>
                </td>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" outline icon="warning">
                  Su búsqueda para <b>"{{ auditPowerSearch }}"</b> no obtuvo resultados.
                </v-alert>
              </template>
            </v-data-table>

            <v-dialog v-model="dialogPowersHistory" scrollable max-width="920px">               
              <v-card>
                <v-card-title class="title">Histórico de Poderes - {{ powerHistoryFamilyName }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px;" class="pa-0">
                  
                  <v-data-table
                    :headers="powersHistoryHeaders"
                    :items="powerHistoryDetail"
                    :items-per-page="10"
                    :rows-per-page-text="$t('datatable.rowsPerPageText')"
                    :no-results-text="$t('datatable.noResultsText')"
                    :no-data-text="$t('datatable.noDataText')"
                    :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
                    :loading="isLoading"
                    class="mt-2"
                  >
                    <template v-slot:items="props">
                      <tr :class="props.item.status == '1' ? 'grey--text' : ''">
                        <td>{{ props.item.created_at.substr(0, 16) }}</td>
                        <td>{{ props.item.document_name }} {{ props.item.status }}</td>
                        <td>{{ props.item.family_receives_power_id }}<br>{{ props.item.family_receives_name }}</td>
                        <td>{{ props.item.family_receives_power_status }}<br>{{ props.item.family_receives_power_status ? props.item.family_receives_power_updated_at.substring(0,16) : props.item.created_at.substring(0,16) }}
                        <td>{{ props.item.document_status }}</td>
                      </tr>
                    </template>
                  </v-data-table>                    

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" flat @click="dialogPowersHistory = false">{{ $t('close') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogDigitalSign"
              fullscreen>
              <!-- <v-layout>
                <v-flex style="background-color:white;" lg4>
                  <b>signAction: {{ signAction }}</b><br>
                  rowidTercero: {{ rowidTercero }}<br>
                  documentSignId: {{ documentSignId }}<br>
                  vistaAction: {{ vistaAction }}<br>
                  documentProcessId: {{ documentProcessId }}<br>
                  vistaRecordId: {{ vistaRecordId }}
                </v-flex>
              </v-layout> -->
              <DigitalSignComponent
                v-if="dialogDigitalSign"
                v-on:closeDialog="dialogDigitalSign = false"
                :documentId="documentSignId"
                :action="vistaAction"
                :processId="documentProcessId"
                :recordId="vistaRecordId"
              ></DigitalSignComponent>
            </v-dialog>

            <v-dialog
              v-model="dialogRejectPower"
              max-width="680"
            >
              <v-card>
                <v-card-title class="title red--text text--darken-4">Rechazo de documento de poder (asamblea virtual)</v-card-title>
                <v-card-text>
                  <v-container grid-list-md text-xs-center px-0>
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-select
                          :items="[
                            { value: 'fotografía', name: 'Rechazo por Fotografía' },
                            { value: 'firma', name: 'Rechazo por Firma' },
                          ]"
                          v-model="toRejectReason"
                          label="Razón del rechazo"
                          item-text="name"
                          item-value="value"
                          ></v-select>
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field 
                          v-model="toRejectObservation"
                          label="Observaciones (Visibles para el usuario)"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  Está seguro de rechazar el documento # <b>{{ toRejectPowerId }}</b> de la familia <b>{{ toRejectFamilyName }}</b>?
                  <br>
                  <small>Recuerde que además del rechazo del documento, le llegará una notificación vía correo electrónico, indicando que el rechazo fue por motivo de calidad en la información</small>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    color="red darken-4"
                    flat="flat"
                    :disabled="!toRejectReason || !toRejectObservation"
                    @click="rejectPower"
                  >
                    {{ $t('accept') }}
                  </v-btn>

                  <v-btn
                    color="grey"
                    flat="flat"
                    @click="dialogRejectPower = false"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogAudit = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</div>

</template>
<script>
import axios from 'axios'
import DigitalSignComponent from '~/pages/documents/digital_sign'
import Form from 'vform';
import FileUpload from 'vue-upload-component'

export default {
  name: 'assemblies-show-view',
  components: {
    DigitalSignComponent,
    FileUpload
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Fecha de asamblea', align: 'center', value: 'assembly_date' },
        { text: 'Tipo', align: 'center', value: 'assembly_type' },
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Responsable', align: 'center', value: 'responsible_name' },
        { text: 'Máx. Poderes', align: 'center', value: 'delegated_powers_limit', sortable: false },
        { text: 'Mín. Asist', align: 'center', value: 'min_attendance_percentage', sortable: false },
        { text: 'Estado', align: 'center', value: 'status' },
        { text: 'Acciones', align: 'center', value: 'assembly_date', sortable: false }
      ],
      assemblies: [],
      modalDeleteAssembly: false,
      selectedAssembly: { description: '', id: null },
      dialog: false,
      dialogAudit: false,
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentMemberSearch: null,
      searchBoardMembers: null,
      boardMembersHeaders: [
        { text: 'Nombre', value: 'name', align: 'center' },
        { text: 'Actions', value: 'name', sortable: false, align: 'center' }
      ],
      boardMembers: [],
      boardMembersSearch: '',
      auditPowerHeaders: [
        { text: 'Poderdante', value: 'family_name', sortable: true, align: 'center' },
        { text: 'Tipo', value: 'asopaf', sortable: true, align: 'center' },
        { text: 'Vista 360', align: 'center' },
        { text: 'Apoderado', value: 'family_receives_name', align: 'center' },
        { text: 'Estado', value: 'family_receives_power_status', sortable: true, align: 'center' },
        { text: 'Vista 360', align: 'center', width: '100px' }
      ],
      auditPowerItems: [],
      auditPowerSearch: null,
      dialogPowersHistory: false,
      powerHistoryFamilyName: null,
      powersHistoryHeaders: [
        { text: 'Fecha', value: 'created_at', align: 'center' },
        { text: 'Documento', value: 'document_name', sortable: false },
        { text: 'Familia destino', value: 'family_receives', sortable: false },
        { text: 'Estado Apoderado', value: 'family_receives_power_status', align: 'center', width: '50px' },
        { text: 'Estado Vista 360', value: 'document_status', align: 'center' },
      ],
      powerHistoryDetail: [],

      dialogDigitalSign: false,
      documentSignId: 0,
      vistaAction: null,
      documentProcessId: 0,
      vistaRecordId: 0,
      dialogRejectPower: false,
      toRejectPowerId: null,
      toRejectFamilyId: null,
      toRejectFamilyName: '',
      toRejectReason: null,
      toRejectObservation: null,

      questionsTab: null,
      assemblyQuestions: [],
      assemblyAnswers: [],
      assemblyQuorum: [],
      dialogQuestions: false,
      modalEditQuestion: false,
      modalRemoveQuestion: false,
      modalActiveQuestion: false,
      modalDeactiveQuestion: false,
      selectedQuestion: {},
      selectedOption: null,
      selectedQuestionIndex: null,
      target_audiences: [
        { value: 'GENERALPUBLIC',  text: this.$t('assembly.target_audiences.generalpublic') },
        { value: 'ASOPAF',  text: this.$t('assembly.target_audiences.asopaf') },
      ],
      files: [],
      fileDialog: false,
      rulesQuestion: {
        required: value => !!value || 'Requerido',
        counter: value => value.length <= 100 || 'Max 100 caracteres',
      },
      newQuestionDetail: '',

      showCreateMemberForm: false,
      createMemberForm: new Form({
        name: ''
      }),
      loadingTable: false,
    }
  },
  created() {
    this.getAssembliesList()
  },
  methods: {
    myAlert(msg){
        alert(msg)
    },
    async getAssembliesList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/assemblies')
      this.assemblies = data;
      this.loadingTable = false;
    },
    auditPowers(assembly) {
      this.auditPowerItems = []
      this.dialogAudit = true
      this.selectedAssembly = assembly
      this.isLoading = true
      axios.get(`/api/documents/get_powers/${assembly.id}`)
        .then(response => {
          if (response.status === 200) {
            this.auditPowerItems = response.data
            this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false
        })
    },
    showPowersHistory(idFamily, familyName){
      this.dialogPowersHistory = true
      this.powerHistoryDetail = []
      this.powerHistoryFamilyName = `${familyName}`
      this.isLoading = true
      axios.get(`/api/documents/get_powers_detail/${this.selectedAssembly.id}/${idFamily}`)
        .then(response => {
          if (response.status === 200) {
            this.powerHistoryDetail = response.data
            this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false
        })
    },
    viewPower(vista_id){
      this.dialogDigitalSign = true
      this.vistaAction = 'SHOW'
      this.vistaRecordId = vista_id
    },
    rejectPowerPrompt(vista_id, family_id, family_name){
      this.dialogRejectPower = true
      this.toRejectPowerId = vista_id
      this.toRejectFamilyName = family_name
      this.toRejectFamilyId = family_id
      this.toRejectReason = null
      this.toRejectObservation = null
      // this.dialogDigitalSign = true
      // this.vistaAction = 'SHOW'
      // this.vistaRecordId = vista_id
    },
    checkPower(id, actual_status){
      axios.post('/api/documents/check_power', { id : id })
        .then(response => {
          if (response.status === 200) {
            this.isLoading = false
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text:  `Poder ${actual_status ? '"no-revisado"' : '"revisado"' } correctamente`,
            })
            this.auditPowers(this.selectedAssembly)
          }
        })
        .catch(error => {
          this.$store.dispatch('responseMessage', {
                type: 'error',
                text:  'Ocurrió un error',
                modal: true
            })
        })
    },
    rejectPower(){
      this.isLoading = true
      let context = this
      let payload = {
          id: context.toRejectPowerId, 
          family_id: context.toRejectFamilyId,
          family_name: context.toRejectFamilyName,
          assembly_id: context.selectedAssembly.id,
          assembly_name: context.selectedAssembly.description,
          reason: context.toRejectReason,
          observation: context.toRejectObservation
        }
      axios.post('/api/documents/reject_document', payload)
        .then(response => {
          if (response.status === 200) {
            context.isLoading = false
            context.dialogRejectPower = false
            context.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Poder rechazado correctamente (notificado a la familia vía correo electrónico)',
                modal: true
            })
            context.auditPowers(context.selectedAssembly)
          }
        })
        .catch(error => {
          context.$store.dispatch('responseMessage', {
                type: 'error',
                text:  'Ocurrió un error',
                modal: true
            })
        })
    },
  },
}
</script>

<style>
.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
 .upload-files {
   color: gray;
   padding: 5px;
 }
 .cursor-help {
   cursor: help;
 }
 a.v-tabs__item:hover {
  text-decoration: none !important;
  font-weight: bolder;
 }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/powersaudit.vue